/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyWorkflowIcon = createIcon("EmptyWorkflowIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M60.006 58c1.101 0 1.994.895 1.994 1.994v12.012A1.995 1.995 0 0160.006 74H47.994A1.995 1.995 0 0146 72.006v-4.984l-11.993-.017a1 1 0 00-1 .875l-.007.116V86.03c0 .537.45.993 1.007.993L46 87.022v-5.028c0-1.101.895-1.994 1.994-1.994h12.012c1.101 0 1.994.894 1.994 1.994v12.012A1.995 1.995 0 0160.006 96H47.994A1.995 1.995 0 0146 94.006v-4.984H32.994a2 2 0 01-1.988-1.856l-.006-.15v-20.01c0-1.108.893-2.005 1.994-2.003L46 65.022v-5.028c0-1.101.895-1.994 1.994-1.994h12.012Zm16.001-14.997a1.998 1.998 0 011.994 2.004v20.009a2 2 0 01-1.994 2.007H62.001v-2h12.994A1 1 0 0076 64.03V45.996c0-.537-.45-.992-1.006-.991l-12.992.02-.003-2 14.007-.022ZM60.006 36c1.101 0 1.994.895 1.994 1.994v12.012A1.995 1.995 0 0160.006 52H47.994A1.995 1.995 0 0146 50.006V37.994c0-1.101.895-1.994 1.994-1.994h12.012Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 31.994c0-1.101.895-1.994 1.994-1.994h12.012c1.101 0 1.994.895 1.994 1.994v12.012A1.995 1.995 0 0166.006 46H53.994A1.995 1.995 0 0152 44.006V31.994Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 42.998c0 .553.456 1.002 1.002 1.002h9.995c.554 0 1.003-.456 1.003-1.002v-9.995c0-.554-.456-1.003-1.002-1.003h-9.996C54.45 32 54 32.456 54 33.002v9.995Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 53.994c0-1.101.895-1.994 1.994-1.994h12.012c1.101 0 1.994.895 1.994 1.994v12.012A1.995 1.995 0 0166.006 68H53.994A1.995 1.995 0 0152 66.006V53.994Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 64.998c0 .553.456 1.002 1.002 1.002h9.995c.554 0 1.003-.456 1.003-1.002v-9.996C66 54.45 65.544 54 64.998 54h-9.996C54.45 54 54 54.456 54 55.002v9.995Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 75.994c0-1.101.895-1.994 1.994-1.994h12.012c1.101 0 1.994.894 1.994 1.994v12.012A1.995 1.995 0 0166.006 90H53.994A1.995 1.995 0 0152 88.006V75.994Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 86.998c0 .553.456 1.002 1.002 1.002h9.995c.554 0 1.003-.456 1.003-1.002v-9.996C66 76.45 65.544 76 64.998 76h-9.996C54.45 76 54 76.456 54 77.002v9.996Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.001 58.03a1 1 0 01-1.006.993H68v2h14.006A2 2 0 0084 59.016v-20.01a1.998 1.998 0 00-1.994-2.003L68 37.024l.003 2 12.992-.02c.556 0 1.006.455 1.006.992V58.03ZM39 61.996c0-.549.45-.992 1.007-.992l12.992.02.002-2-14.007-.021A1.997 1.997 0 0037 61.007v20.009c0 1.108.895 2.007 1.994 2.007H53v-2H40.007A1.007 1.007 0 0139 80.03V61.996Z",
    fill: "#0C0D0D"
  }));
}, {
  "i18nKey": "svg.EmptyWorkflowIcon"
});